import { fetchWithoutToken } from '../utils/fetch';

export const getNews = async (institutionCode) => {
	try {
		const response = await fetchWithoutToken.get(
			`/custom_news/?only_active=true&institution_code=${institutionCode}`,
			{
				headers: {
					accept: 'application/json',
					Authorization: `Bearer ${localStorage.token}`,
				},
			}
		);
		return response.data;
	} catch (error) {
		throw error;
	}
};
